import { FieldValues, Path, useController, UseFormReturn } from "react-hook-form";

import { isRequired } from "../../../../../../common/helpers/validators";

import { useTranslate } from "@/common/hooks/useTranslate";
import { QuestionOutput } from "@/common/types/trpc";
import { FormPhoneInputField } from "@/forms-design-system/FormPhoneInputField";

interface QuestionFieldPhoneProps<T extends FieldValues> {
  form: UseFormReturn<T>;
  name: Path<T>;
  label: string;
  question: QuestionOutput;
  country: string;
}

export function QuestionFieldPhone<T extends FieldValues>({
  name,
  form,
  label,
  question,
  ...rest
}: QuestionFieldPhoneProps<T>) {
  const { t } = useTranslate();
  const {
    field: { value, onChange, ref, onBlur },
    fieldState: { error },
  } = useController({
    name,
    control: form.control,
    rules: isRequired(question.required, t("common", "answerRequired")),
  });

  return (
    <FormPhoneInputField
      id={name}
      label={label}
      error={Boolean(error)}
      helperText={error?.message}
      data-test="question-field-phone-number"
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      inputRef={ref}
      required={question.required}
      sx={{ width: "100%" }}
      {...rest}
    />
  );
}
